import { gql } from "@apollo/client";
import classNames from "classnames";
import NewsSection from "../../components/PageComponents/Home/NewsSection/NewsSection";
import PageHeader from "../../components/PageHeader/PageHeader";
import { client } from "../../lib/apollo";
import { newsHeadTitleQuery } from "../../lib/queries/newsHeadTitleQuery";
import { newsItemsQuery } from "../../lib/queries/newspage";
import { NewsItemsProps } from "../../types/NewsItemsProps";
import styles from "./News.module.scss";
import ReadArticle from "./ReadArticle/ReadArticle";

const NewsPage = ({ newsItems, headTitle, error, loading }: NewsItemsProps) => {
  let title = "";
  headTitle?.pages.nodes?.map((el: any) => {
    if (el.newsSections.newsSections.length > 0) {
      title = el.newsSections.newsSections[0].newspageHeadTitle;
    }
  });
  const latestNews = newsItems.data && newsItems?.data?.posts?.nodes[0];
  return (
    <section className={classNames(styles.element)}>
      {!loading && !error && title && <PageHeader title={"News"} />}
      <div className={classNames(styles.newsContainer)}>
        {!newsItems.loading && !newsItems.error && newsItems.data && (
          <>
            <div className={classNames(styles.wrapper, "container")}>
              <ReadArticle
                desc={latestNews.excerpt}
                image={latestNews.featuredImage.node.sourceUrl}
                readLink={`/news/article/${latestNews.slug}`}
                title={latestNews.title}
              />
            </div>
            <NewsSection hasTitle={false} newsItems={newsItems.data} />
          </>
        )}
      </div>
    </section>
  );
};

export default NewsPage;

export async function getStaticProps({ locale }: { locale: any }) {
  const { data } = await client.query({
    query: gql`
      ${newsItemsQuery}
    `,
    variables: {
      language: "EN",
    },
  });
  const headTitle = await client.query({
    query: gql`
      ${newsHeadTitleQuery}
    `,
    variables: {
      language: "EN",
    },
  });

  return {
    props: {
      newsItems: data,
      headTitle: headTitle.data,
    },
  };
}
